import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import GenericAddressField from 'components/form/GenericAddressField'
import SelectField from 'components/form/SelectField'
import styles from './styles.scss'
import {
  UNIT_NUMBER_KEY,
  UNIT_TYPE_KEY,
  STREET_NUMBER_KEY,
  STREET_NAME_KEY,
  STREET_TYPE_KEY,
  SUBURB_KEY,
  STATE_KEY,
  POSTCODE_KEY,
  STATE_SELECTION,
  UNIT_TYPE_SELECTION,
  STREET_TYPE_SELECTION,
} from './constants'

class Address extends Component {
  static propTypes = {
    onFieldUpdated: PropTypes.func,
    loading: PropTypes.bool,
    fieldValues: PropTypes.object,
    fieldErrors: PropTypes.object,
  }

  static defaultProps = {
    onFieldUpdated: f => f,
    loading: false,
    fieldValues: {},
    fieldErrors: {},
  }

  constructor(props) {
    super(props)
    this.focusRef = React.createRef()
    this.state = {
      fieldValues: {
        [UNIT_NUMBER_KEY]: '',
        [UNIT_TYPE_KEY]: '',
        [STREET_NUMBER_KEY]: '',
        [STREET_NAME_KEY]: '',
        [STREET_TYPE_KEY]: '',
        [SUBURB_KEY]: '',
        [STATE_KEY]: '',
        [POSTCODE_KEY]: '',
        // allow incoming values to override default empty
        ...props.fieldValues,
      },
    }
  }

  onFieldChange = (value, fieldname) => {
    this.setState({
      fieldValues: {
        ...this.state.fieldValues,
        [fieldname]: value,
      },
    })
  }

  onFieldBlur = (value, fieldname) => {
    if (this.props.fieldValues[fieldname] !== this.state.fieldValues[fieldname]) {
      this.props.onFieldUpdated({ [fieldname]: value })
    }
  }

  onSelectChangeHandler = (event) => {
    this.onFieldChange(event.target.value, event.target.name)
    this.onFieldBlur(event.target.value, event.target.name)
  }
  onFieldChangeHandler = event => this.onFieldChange(event.target.value, event.target.name)
  onFieldBlurHandler = event => this.onFieldBlur(event.target.value, event.target.name)
  onKeyPressHandler = (event) => {
    if (event.key === 'Enter') {
      this.onFieldBlur(event.target.value, event.target.name)
    }
  }
  focus = () => this.focusRef.current.focus()

  render() {
    const { loading, fieldErrors } = this.props
    const { fieldValues } = this.state

    return (
      <Fragment>
        <div className={styles.field_unit_number} ref={this.focusRef}>
          <GenericAddressField
            label="Unit Number"
            name={UNIT_NUMBER_KEY}
            value={fieldValues[UNIT_NUMBER_KEY]}
            errorMessage={fieldErrors[UNIT_NUMBER_KEY]}
            onChange={this.onFieldChangeHandler}
            onBlur={this.onFieldBlurHandler}
            onKeyPress={this.onKeyPressHandler}
            loading={loading}
          />
        </div>
        <div className={classNames(styles.field_select, styles.field_unit_type)}>
          <SelectField
            label="Unit Type"
            options={UNIT_TYPE_SELECTION}
            name={UNIT_TYPE_KEY}
            value={fieldValues[UNIT_TYPE_KEY]}
            errorMessage={fieldErrors[UNIT_TYPE_KEY]}
            onChange={this.onSelectChangeHandler}
            onBlur={this.onFieldBlurHandler}
            onKeyPress={this.onKeyPressHandler}
            loading={loading}
          />
        </div>
        <div className={styles.field_break} />
        <div className={styles.field_street_number}>
          <GenericAddressField
            label="Street Number"
            name={STREET_NUMBER_KEY}
            value={fieldValues[STREET_NUMBER_KEY]}
            errorMessage={fieldErrors[STREET_NUMBER_KEY]}
            onChange={this.onFieldChangeHandler}
            onBlur={this.onFieldBlurHandler}
            onKeyPress={this.onKeyPressHandler}
            loading={loading}
            required
          />
        </div>
        <div className={styles.field_street_name}>
          <GenericAddressField
            label="Street Name"
            name={STREET_NAME_KEY}
            value={fieldValues[STREET_NAME_KEY]}
            errorMessage={fieldErrors[STREET_NAME_KEY]}
            onChange={this.onFieldChangeHandler}
            onBlur={this.onFieldBlurHandler}
            onKeyPress={this.onKeyPressHandler}
            loading={loading}
            required
          />
        </div>
        <div className={classNames(styles.field_select, styles.field_street_type)}>
          <SelectField
            label="Street Type"
            options={STREET_TYPE_SELECTION}
            name={STREET_TYPE_KEY}
            value={fieldValues[STREET_TYPE_KEY]}
            errorMessage={fieldErrors[STREET_TYPE_KEY]}
            onChange={this.onSelectChangeHandler}
            onBlur={this.onFieldBlurHandler}
            onKeyPress={this.onKeyPressHandler}
            loading={loading}
            required
          />
        </div>
        <div className={styles.field_break} />
        <div className={styles.field_suburb}>
          <GenericAddressField
            label="Suburb"
            name={SUBURB_KEY}
            value={fieldValues[SUBURB_KEY]}
            errorMessage={fieldErrors[SUBURB_KEY]}
            onChange={this.onFieldChangeHandler}
            onBlur={this.onFieldBlurHandler}
            onKeyPress={this.onKeyPressHandler}
            loading={loading}
            required
          />
        </div>
        <div className={classNames(styles.field_select, styles.field_state)}>
          <SelectField
            label="State"
            options={STATE_SELECTION}
            name={STATE_KEY}
            value={fieldValues[STATE_KEY]}
            errorMessage={fieldErrors[STATE_KEY]}
            onChange={this.onSelectChangeHandler}
            onBlur={this.onFieldBlurHandler}
            onKeyPress={this.onKeyPressHandler}
            loading={loading}
            required
          />
        </div>
        <div className={styles.field_postcode}>
          <GenericAddressField
            label="Postcode"
            name={POSTCODE_KEY}
            value={fieldValues[POSTCODE_KEY]}
            errorMessage={fieldErrors[POSTCODE_KEY]}
            onChange={this.onFieldChangeHandler}
            onBlur={this.onFieldBlurHandler}
            onKeyPress={this.onKeyPressHandler}
            loading={loading}
            required
          />
        </div>
        <div className={styles.field_break} />
      </Fragment>
    )
  }
}

export default Address



// WEBPACK FOOTER //
// ./components/Address/index.jsx